import React from 'react'

const ImportantNotes = () => {
  return (
    <div className="jc_notes_container p-3 mb-3">
                <p className='jc_notes_head'>Important Notes!</p>

                <div className="line_divide"></div>

                <div className="jc_notes mt-3">
        <p>AI That Understands Hiring: eBench uses intelligent algorithms to match you with the right candidates—fast, accurately, and with zero guesswork.</p>
        <p>Vetted Professionals Only: Every candidate is thoroughly assessed for skills, experience, and fit—saving you time and ensuring quality.</p>
        <p>All-in-One Hiring Platform: Post jobs, manage candidates, schedule interviews, and onboard—all from one intuitive dashboard.</p>
        <p>Reduce Time & Cost: Cut hiring time by up to 70% and avoid the costs of bad hires with data-backed decision-making.</p>
        <p>Global Reach, Local Compliance: Find top remote talent while ensuring full compliance with employment laws across regions.</p>

                </div>
            </div>
  )
}

export default ImportantNotes